import { BaseContext } from '../utils/basecontext';
import { HttpClientImpl } from '../utils/httpclient/httpclient';
import { BannerProcessorFactory } from './processorfactory/bannerprocessorfactory';
import { CategoriesProcessorFactory } from './processorfactory/categoriesprocessorfactory';
import { FaqProcessorFactory } from './processorfactory/faqprocessorfactory';
import { FeaturedCategoriesProcessorFactory } from './processorfactory/featuredcategoriesprocessorfactory';
import { KaroakeProcessorFactory } from './processorfactory/karoakeprocessorfactory';
import { ListLikeToneProcessorFactory } from './processorfactory/listliketoneprocessorfactory';
import { LoginProcessorFactory } from './processorfactory/loginprocessorfactory';
import { MyAccountProcessorFactory } from './processorfactory/myaccountprocessorfactory';
import { MyTunesProcessorFactory } from './processorfactory/mytunesprocessorfactory';
import { SalatiProcessorFactory } from './processorfactory/salatiprocessorfactory';
import { SearchToneProcessorFactory } from './processorfactory/searchtoneprocessorfactory';
import { SpecificSearchToneProcessorFactory } from './processorfactory/specificsearchtoneprocessorfactory';
import { ToneProcessorFactory } from './processorfactory/toneprocessorfactory';
import { GroupProcessorFactory } from './processorfactory/groupprocessorfactory';
import { BlacklistProcessorFactory } from './processorfactory/blacklistprocessorfactory';
import { SubscriptionPlanDetailsProcessorFactory } from './processorfactory/subscriptionprocessorfactory';
import { NameTuneProcessorFactory } from './processorfactory/nametuneprocessorfactory';

export interface SixdeeCRBTAPIProcessorFactory 
{
    getLoginAPIProcessorFactory(): LoginProcessorFactory;
    getBannerAPIProcessorFactory(): BannerProcessorFactory;
    getFeaturedCategoriesAPIProcessorFactory(): FeaturedCategoriesProcessorFactory;
    getCategoriesAPIProcessorFactory(): CategoriesProcessorFactory;
    getSearchToneProcessorFactory(): SearchToneProcessorFactory;
    getSpecificSearchToneProcessorFactory(): SpecificSearchToneProcessorFactory;
    getFaqProcessorFactory(): FaqProcessorFactory;
    getListLikeToneProcessorFactory(): ListLikeToneProcessorFactory;
    getToneProcessorFactory(): ToneProcessorFactory;
    getMyAccountProcessorFactory(): MyAccountProcessorFactory;
    getSalatiProcessorFactory(): SalatiProcessorFactory;
    getKaroakeProcessorFactory(): KaroakeProcessorFactory;
    getMyTunesProcessorFactory(): MyTunesProcessorFactory;
    getGroupProcessorFactory(): GroupProcessorFactory;
    getBlacklistProcessorFactory(): BlacklistProcessorFactory;
    getSubscriptionPlanDetailsProcessorFactory():SubscriptionPlanDetailsProcessorFactory;
    getNameTuneProcessorFactory(): NameTuneProcessorFactory;
}

export class SixdeeCRBTAPIProcessorFactoryImpl implements SixdeeCRBTAPIProcessorFactory 
{
    constructor(private context: BaseContext)
    {
    }
   
    
    getContext(): BaseContext
    {
        return this.context;
    }

    getLoginAPIProcessorFactory(): LoginProcessorFactory 
    {
        return new LoginProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getBannerAPIProcessorFactory(): BannerProcessorFactory 
    {
        return new BannerProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getCategoriesAPIProcessorFactory(): CategoriesProcessorFactory 
    {
        return new CategoriesProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getFeaturedCategoriesAPIProcessorFactory(): FeaturedCategoriesProcessorFactory 
    {
        return new FeaturedCategoriesProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getSearchToneProcessorFactory(): SearchToneProcessorFactory 
    {
        return new SearchToneProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getSpecificSearchToneProcessorFactory(): SpecificSearchToneProcessorFactory 
    {
        return new SpecificSearchToneProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getFaqProcessorFactory(): FaqProcessorFactory 
    {
        return new FaqProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getListLikeToneProcessorFactory(): ListLikeToneProcessorFactory 
    {
        return new ListLikeToneProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getToneProcessorFactory(): ToneProcessorFactory
    {
        return new ToneProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getMyAccountProcessorFactory(): MyAccountProcessorFactory
    {
        return new MyAccountProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getSalatiProcessorFactory(): SalatiProcessorFactory
    {
        return new SalatiProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getKaroakeProcessorFactory(): KaroakeProcessorFactory
    {
        return new KaroakeProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getMyTunesProcessorFactory(): MyTunesProcessorFactory
    {
        return new MyTunesProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getGroupProcessorFactory(): GroupProcessorFactory
    {
        return new GroupProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getBlacklistProcessorFactory(): BlacklistProcessorFactory
    {
        return new BlacklistProcessorFactory(this.getContext(), new HttpClientImpl());
    }

    getSubscriptionPlanDetailsProcessorFactory(): SubscriptionPlanDetailsProcessorFactory {
        return new SubscriptionPlanDetailsProcessorFactory(this.getContext(), new HttpClientImpl());
    }
    getNameTuneProcessorFactory(): NameTuneProcessorFactory
    {
        return new NameTuneProcessorFactory(this.getContext(), new HttpClientImpl());
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/apiprocessorfactory.tsx